import PasswordChangeForm from './PasswordChangeForm'

export default PasswordChangeForm



// WEBPACK FOOTER //
// ./src/components/PasswordChangeForm/index.js